import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BodyTypes, GalleryItems } from 'src/app/helpers';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

const url = window.location.href;
const urlObj = new URL(url);
const params = new URLSearchParams(urlObj.search);
const vehicleId = params.get('vehicleId');
const bodyTypeId = params.get('bodyTypeId');

if (vehicleId) {
  localStorage.setItem('vehicleId', vehicleId);
}

if (bodyTypeId) {
  localStorage.setItem('bodyTypeId', bodyTypeId);
}

@Component({
  selector: 'app-report2',
  templateUrl: './report2.component.html',
  styleUrls: ['./report2.component.scss'],
})
export class Report2Component implements OnInit {
  public loaded: boolean = false;
  public vehicleBodyTypes: object = {
    bus: BodyTypes.bus,
    suv: BodyTypes.suv,
    sedan: BodyTypes.sedan,
    truckDouble: BodyTypes.truckDouble,
    truckSingle: BodyTypes.truckSingle,
    cargo: BodyTypes.cargo,
  };
  public lang: string = null;

  public vinInfo: object = null;
  public information: object[] = [];

  public details: object[] = [];
  public flags: string[] = [];
  public options: object[] = [];
  public galleryData: object[] = [];
  public ratings: object = {};

  public mainImage: string = null;
  public calculatedScore: string | number = null;
  public PerceivedScore: string | number = null;

  public main: Object[] = [];

  public subscriptions: Subscription[] = [];
  public reportInfo: any;
  public accessToken: any;
  public accessvehicleId: any;
  public accessRole: any;
  public accessdata: object = {};
  public getaccessdata: object = {};

  public marketValueChecked: boolean = false;
  public purchaseValueChecked: boolean = false;
  public totalRepairCostChecked: boolean = false;

  // start
  vehicleId2: string;
  bodyTypeId2: string;
  accessToken2: string;

  constructor(
    public sharedService: SharedService,
    public ratingService: RatingService,
    public userService: UserService,
    public galleryService: GalleryService,
    public localeService: LocaleService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.vehicleId2 = params['vehicleId'];
      this.bodyTypeId2 = params['bodyTypeId'];
      this.accessToken2 = params['accessToken'];
    });

    localStorage.setItem('accessToken', this.accessToken2);
    // localStorage.setItem('vehicleId', this.vehicleId2);

    this.isVinInfo = false;
    if (
      this.activatedRoute.snapshot.queryParams.access_token &&
      this.activatedRoute.snapshot.queryParams.vehicle_id &&
      this.activatedRoute.snapshot.queryParams.role
    ) {
      this.sharedService.setQueryParamCheck = true;

      const data = {
        token: this.activatedRoute.snapshot.queryParams.access_token,
        vehicleid: this.activatedRoute.snapshot.queryParams.vehicle_id,
        user: {
          user_data: {
            role: this.activatedRoute.snapshot.queryParams.role,
          },
        },
      };

      this.accessdata = data;
      if (Object.keys(this.accessdata).length) {
        this.authService.userSubject.next(this.accessdata);
        localStorage.setItem('user', JSON.stringify(this.accessdata));
        this.sharedService.setVehicleId =
          this.activatedRoute.snapshot.queryParams.vehicle_id;
      }
      this.getaccessdata = JSON.parse(localStorage.getItem('user') as any);
    }

    this.getVinDetails();
    this.allConditions();
    this.getPlaceholderData();
  }

  public isVinInfo = false;
  ngOnInit(): void {
    let vinInfo = setInterval(() => {
      const data = JSON.parse(localStorage.getItem('vinInfo'));
      if (data) {
        this.vinInfo = data;
        this.isVinInfo = true;
        this.getVinDetails();
        this.allConditions();
        this.getPlaceholderData();
        this.mainParts('Exterior');
        clearInterval(vinInfo);
      }
    }, 1000);

    this.localeService.localeSubject.subscribe((res) => {
      this.lang = res;
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.vinInfo = res) : (this.vinInfo = null);
      if (res) {
        this.isVinInfo = true;
      }
    });

    this.mainParts('Exterior');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getVinDetails() {
    let vehicleId: object = {};
    if (this.vehicleId2) {
      vehicleId = {
        vehicle_id: this.vehicleId2,
      };
    } else {
      let vehiId: any = this.getaccessdata;
      vehicleId = {
        vehicle_id: vehiId.vehicleid,
      };
    }

    const informationSub = this.userService.GetVinInfo(vehicleId).subscribe(
      (res) => {
        let success = res['success'];
        if (success) {
          let data = res['data'];
          this.information =
            data &&
            Object.keys(data) &&
            Object.keys(data['vehicle_information'])
              ? data['vehicle_information']
              : {};
          this.calculatedScore = this.information['calculated_value'];
          this.PerceivedScore = this.information['perceived_value'];
          this.details =
            data && Object.keys(data) && Object.keys(data['vehicle_details'])
              ? data['vehicle_details']
              : {};
          this.options =
            data &&
            Object.keys(data) &&
            Object.keys(data['vehicle_options_data'])
              ? data['vehicle_options_data']['options']
              : {};
          const flagsAll =
            data && Object.keys(data) && Object.keys(data['vehicle_flags_data'])
              ? data['vehicle_flags_data']['flags']
              : {};

          for (const key in flagsAll) {
            if (Object.prototype.hasOwnProperty.call(flagsAll, key)) {
              if (flagsAll[key]) {
                if (
                  this.flags.indexOf(key.replace(new RegExp('_', 'g'), ' ')) ===
                  -1
                ) {
                  this.flags.push(key.replace(new RegExp('_', 'g'), ' '));
                }
              }
            }
          }
        }
      },
      (error) => {}
    );
    this.subscriptions.push(informationSub);
  }

  mainParts(type: string) {
    let data: MainParts = {
      body_type_id: this.bodyTypeId2,
      parts_condition_type: type,
      parent_id: null,
    };

    this.loaded = true;
    this.ratingService.getPartsCondition(data).subscribe(
      (res) => {
        let success: boolean = res['success'];
        let data: Object = res['data'];

        if (success) {
          this.loaded = false;
          this.main = data['ratings'];
        }
      },
      (error) => {
        this.loaded = false;
      }
    );
  }

  allConditions() {
    let data: object = {};
    if (this.vehicleId2) {
      data = {
        vehicle_id: this.vehicleId2,
      };
    } else {
      let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
      data = {
        vehicle_id: vehiId.vehicleid,
      };
    }

    this.ratingService.getAllConditions(data).subscribe(
      (res) => {
        let success: boolean = res['success'];

        if (success) {
          let data: object = res['data'];
          Object.assign(this.ratings, {
            market_value: data['market_value'] || 'N/A',
            purchase_value: data['purchase_value'] || 'N/A',
            total_repair_cost: data['total_repair_cost'] || 'N/A',
            exterior: data['exterior'],
            interior: data['interior'],
            mechanics: data['mechanics'],
            frame: data['frame'],
            major_options: data['major_options'],
          });
        }
      },
      (error) => {}
    );
  }

  getPlaceholderData() {
    let getPlaceholderSub = this.galleryService
      .getGalleryPlaceholder()
      .subscribe(
        (res) => {
          let success: boolean = res['success'];
          let data: Object[] = res['data']['gallerys'];
          let url: string = res['data']['url'];

          if (success) {
            const allItems = data.map((item: any) => ({
              gallery_id: item.gallery_id,
              gallery_name: item.gallery_name,
              gallery_name_arabic: item.gallery_name_arabic,
              gallery_placeholder: `${url}${item.gallery_placeholder}`,
              isImage: false,
            }));

            // this.sharedService.setGallerySubmission = this.allItems;
            this.getGalleryData(allItems);
          }
        },
        (error) => {}
      );
    this.subscriptions.push(getPlaceholderSub);
  }

  getGalleryData(placeholders: Record<string, any>[]) {
    let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
    let vehicleId: any;
    // let vehicleId: string = this.sharedService.getVehicleId;
    if (this.vehicleId2) {
      vehicleId = this.vehicleId2;
    } else {
      vehicleId = vehiId.vehicleid;
    }

    let getGallerySub = this.galleryService.getGallery(vehicleId).subscribe(
      (res) => {
        let success: boolean = res['success'];
        if (success) {
          let data: object = JSON.parse(res['data']?.['vehicle_gallery_data']);
          let gallery: Record<string, any>[] = data
            ? data['parts_images']
            : null;
          let url: string = `${environment.base_path}storage/gallery/images/`;
          if (gallery) {
            for (const placeholder of placeholders) {
              for (const item of gallery) {
                if (placeholder.gallery_id === item.part_id) {
                  if (item['part_name'] === 'Front')
                    this.mainImage = `${url}${item['image']}`;

                  this.galleryData.push({
                    ...placeholder,
                    image: `${url}${item['image']}`,
                  });
                }
              }
            }
          }
        }
      },
      (error) => {}
    );
    this.subscriptions.push(getGallerySub);
  }

  dataTypeChecker(data: any) {
    switch (typeof data) {
      case 'string':
        return 'string';

      case 'object':
        return 'object';

      default:
        return undefined;
    }
  }

  handleMarketValueCheck(event: Event) {
    this.marketValueChecked = (event.target as HTMLInputElement).checked;
  }

  handlePurchaseValueCheck(event: Event) {
    this.purchaseValueChecked = (event.target as HTMLInputElement).checked;
  }

  handleTotalRepairCostCheck(event: Event) {
    this.totalRepairCostChecked = (event.target as HTMLInputElement).checked;
  }

  print() {
    window.print();
  }
}

interface MainParts {
  body_type_id: string;
  parts_condition_type: string;
  parent_id?: string;
}
